// extracted by mini-css-extract-plugin
export var acitonButtons = "_hn-0";
export var additionalIcon = "_hn-f";
export var block = "_hn-1";
export var blockContent = "_hn-7";
export var blockDescription = "_hn-8";
export var blockIcon = "_hn-9";
export var blockTitle = "_hn-6";
export var border = "_hn-a";
export var center = "_hn-l";
export var edge = "_hn-b";
export var edgeLabel = "_hn-c";
export var edgePath = "_hn-d";
export var error = "_hn-e";
export var flowchart = "_hn-g";
export var flowchartContent = "_hn-h";
export var highlighted = "_hn-3";
export var hover = "_hn-4";
export var icon = "_hn-i";
export var left = "_hn-m";
export var navButton = "_hn-j";
export var navButtons = "_hn-k";
export var right = "_hn-n";
export var selected = "_hn-2";
export var small = "_hn-5";